import axiosInstance from "../../services/axiosInstance";

import { useQuery } from "react-query";
import CategoryService from "../../services/categoryService";
import { CitiesResponse } from "../../types/category-menu";

const fetchCityPage = async ({ cityId }: { cityId: number }) => {
  const response = await axiosInstance.get(`/cities/` + cityId + "/page", {});
  return response.data?.result;
};

const fetchCityPageBySlug = async ({ slug }: { slug: string }) => {
  const response = await axiosInstance.get(`/cities/slug/` + slug + "/page", {});
  return response.data?.result;
};

const fetchNews = async ({ newsId }: { newsId: number }) => {
  const response = await axiosInstance.get(`/news/` + newsId, {});
  return response.data?.result;
};

export const useCityPageQuery = (slug: string) => {
  return useQuery<CityPageResponseDTO>(["cityPage", slug], () =>
    fetchCityPageBySlug({ slug }),
  );
};

export const useNewsQuery = (newsId: number) => {
  return useQuery<NewsDetailDTO>(["news", newsId], () => fetchNews({ newsId }));
};

export const usePopularCityQuery = () => {
  return useQuery<CitiesResponse>({
    queryKey: ["cities", "popular"],
    queryFn: async () => {
      const response = await CategoryService.getCityCategories();
      if (!response) {
        throw new Error("No data");
      }
      return response;
    },
  });
};
